import React from "react";
import { MdUpload } from "react-icons/md";
import { BsTrashFill } from "react-icons/bs";

import { StyledLabel, DeleteDiv } from "./ImageCM.style";
import ImgContainer from "../Image";

function Upload(props) {
  return (
    <>
      <StyledLabel
        htmlFor={props.type + props.file?.id}
        refillable={props.refillable}
      >
        {props.isWeb ? (
          <ImgContainer
            isWeb
            src={props.file}
            width={props.width}
            height={props.height}
            objectFit={props.objectFit}
          />
        ) : props.isLocal ? (
          <ImgContainer
            src={URL.createObjectURL(props.file)}
            width={props.width}
            height={props.height}
            objectFit={props.objectFit}
          />
        ) : (
          <>
            <MdUpload size={22} />
            بارگذاری عکس جدید
          </>
        )}
        {props.onDelete && (
          <DeleteDiv onClick={props.onDelete}>
            <BsTrashFill />
          </DeleteDiv>
        )}
      </StyledLabel>

      <input
        id={props.type + props.file?.id}
        type="file"
        style={{ display: "none" }}
        onChange={(e) => props.onChange(e.target.files[0])}
        disabled={!props.refillable}
      />
    </>
  );
}

export default Upload;
